<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div id="data-list-list-view" class="data-list-container">
    <h1>{{ $t("validations") }}</h1>
    <br>
    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="missions">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
        
      
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ missions.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : missions.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=40">
              <span>40</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=60">
              <span>60</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=80">
              <span>80</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="mission_ref">{{ $t("mission_ref") }}</vs-th>
        <vs-th sort-key="mission">{{ $t("mission") }}</vs-th>
        <vs-th sort-key="journey">{{ $t("journey") }}</vs-th>
        <vs-th sort-key="evacuationPlan">{{ $t("evacuationPlan") }}</vs-th>
        <vs-th sort-key="riskZones">{{ $t("riskZones") }}</vs-th>
        <vs-th sort-key="jobRiskAssessment_step">{{ $t("jobRiskAssessment_step") }}</vs-th>
        <vs-th sort-key="securityEvaluation">{{ $t("securityEvaluation") }}</vs-th>
        <vs-th sort-key="pessNokia">{{ $t("pessNokia") }}</vs-th>
        <vs-th sort-key="qhsNokia">{{ $t("qhsNokia") }}</vs-th>
        <vs-th sort-key="leadProject">{{ $t("leadProject") }}</vs-th>
        <vs-th sort-key="action">Action</vs-th>

     </template>

      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.poNumber}}</p>
          </vs-td>

          <vs-td>
           <div v-if="tr.missionStep === true" class="flex mb-2">
            <vx-tooltip color="primary" :text="$t('voir_mission')">
              <vs-button @click="missionStep_show(tr)" color="primary" size="default" icon-pack="feather" type="line" icon="icon-eye"></vs-button>    
              </vx-tooltip>
              <vx-tooltip v-if="user_role !== 'nokiaProject' && user_role !== 'qhsNokia' && user_role !== 'teamLeaderSubcontractor'" text="Carte" color="#595b5c">
                <vs-button @click="carte(tr.id)" color="#595b5c" type="line" class="ml-2" icon-pack="feather" icon="icon-globe"></vs-button>
              </vx-tooltip>
            </div>
          </vs-td>

          <vs-td>
            <div v-if="tr.journeyStep === true" class="flex mb-2">
              <vx-tooltip color="primary" :text="$t('voir_trajet')">
              <vs-button  @click="journeyStep_show(tr)" color="primary" size="default" icon-pack="feather" class="ml-2" type="line" icon="icon-eye"></vs-button>    
              </vx-tooltip>
            </div>
          </vs-td>

          <vs-td>          
            <div v-if="tr.evacuationPlanStep === true" class="flex mb-2">
              <vx-tooltip color="primary" :text="$t('voir_evacuation')">
              <vs-button @click="evacuationPlanStep_show(tr)" color="primary" size="default" icon-pack="feather" type="line" icon="icon-eye"></vs-button>    
              </vx-tooltip>
            </div>
          </vs-td>
          
          <vs-td>
          
            <div v-if="tr.riskZoneAssessmentStep === true" class="flex mb-2">
            <vx-tooltip  color="primary" :text="$t('voir_zone_exclusion')">
            <vs-button @click="riskZoneAssessmentStep_show(tr)" color="primary" size="default" icon-pack="feather" type="line" icon="icon-eye"></vs-button>    
            </vx-tooltip>
            <vx-tooltip v-if="user_role === 'nokiaProject'  || user_role === 'qhsNokia' || user_role === 'pessNokia' || user_role === 'admin' && tr.missionRiskZoneAssessment.length"  :color="getOrderMissionColor(tr.id)" :text="$t('alerte')" >
              <vs-button  :color="getOrderMissionColor(tr.id)" size="default" icon-pack="feather" type="line" class="ml-2" icon="icon-alert-triangle"></vs-button>
            </vx-tooltip> 
            </div>
          </vs-td>
          
          <vs-td>
            <div v-if="tr.jobRiskAssessmentStep === true" class="flex mb-2">
              <vx-tooltip color="primary" :text="$t('voir_evaluation_risque')">
              <vs-button  @click="jobRiskAssessmentStep_show(tr)" color="primary" size="default" icon-pack="feather" type="line" icon="icon-eye"></vs-button>    
            </vx-tooltip>
          </div>
          </vs-td>

          <vs-td>
            <div v-if="tr.jobRiskAssessmentStep === true && tr.missionSecurityThreatEvaluations.length" class="flex mb-2">
              <vx-tooltip color="primary" :text="$t('voir_evaluation_securitaire')">
              <vs-button  @click="evalutionSecurityStep_show(tr)" color="primary" size="default" icon-pack="feather" type="line" icon="icon-eye"></vs-button>    
            </vx-tooltip>
            </div>
          </vs-td>
        
        <vs-td v-if="getlang ==='fr'" >
          <vs-chip v-if="tr.pessNokiaValidation === 0" :color="getOrderStatusColor1(tr.pessNokiaValidation)" class="product-order-status">{{'Rejetée'}}</vs-chip> 
          <vs-chip v-if="tr.pessNokiaValidation === 1" :color="getOrderStatusColor1(tr.pessNokiaValidation)" class="product-order-status">{{'Validée'}}</vs-chip> 
          <vs-chip v-if="tr.pessNokiaValidation === 2" :color="getOrderStatusColor1(tr.pessNokiaValidation)" class="product-order-status">{{'Encours'}}</vs-chip> 
        </vs-td>

        <vs-td v-if="getlang ==='en'" >
          <vs-chip v-if="tr.pessNokiaValidation === 0" :color="getOrderStatusColor1(tr.pessNokiaValidation)" class="product-order-status">{{'Rejected'}}</vs-chip> 
          <vs-chip v-if="tr.pessNokiaValidation === 1" :color="getOrderStatusColor1(tr.pessNokiaValidation)" class="product-order-status">{{'Validated'}}</vs-chip> 
          <vs-chip v-if="tr.pessNokiaValidation === 2" :color="getOrderStatusColor1(tr.pessNokiaValidation)" class="product-order-status">{{'Verification'}}</vs-chip> 
        </vs-td>

        <vs-td v-if="getlang ==='fr'" >
          <vs-chip v-if="tr.qhsNokiaValidation === 0" :color="getOrderStatusColor1(tr.qhsNokiaValidation)" class="product-order-status">{{'Rejetée'}}</vs-chip> 
          <vs-chip v-if="tr.qhsNokiaValidation === 1"  :color="getOrderStatusColor1(tr.qhsNokiaValidation)" class="product-order-status">{{'Validée'}}</vs-chip> 
          <vs-chip v-if="tr.qhsNokiaValidation === 2"  :color="getOrderStatusColor1(tr.qhsNokiaValidation)" class="product-order-status">{{'Encours'}}</vs-chip> 
        </vs-td>

        <vs-td v-if="getlang ==='en'" >
          <vs-chip v-if="tr.qhsNokiaValidation === 0" :color="getOrderStatusColor1(tr.qhsNokiaValidation)" class="product-order-status">{{'Rejected'}}</vs-chip> 
          <vs-chip v-if="tr.qhsNokiaValidation === 1"  :color="getOrderStatusColor1(tr.qhsNokiaValidation)" class="product-order-status">{{'Validated'}}</vs-chip> 
          <vs-chip v-if="tr.qhsNokiaValidation === 2"  :color="getOrderStatusColor1(tr.qhsNokiaValidation)" class="product-order-status">{{'Verification'}}</vs-chip> 
        </vs-td>

        <vs-td v-if="getlang ==='fr'" >
        <vs-chip v-if="tr.leadProjectValidation === 0" :color="getOrderStatusColor1(tr.leadProjectValidation)" class="product-order-status">{{'Rejetée'}}</vs-chip> 
        <vs-chip v-if="tr.leadProjectValidation === 1" :color="getOrderStatusColor1(tr.leadProjectValidation)" class="product-order-status">{{'Validée'}}</vs-chip> 
        <vs-chip v-if="tr.leadProjectValidation === 2" :color="getOrderStatusColor1(tr.leadProjectValidation)" class="product-order-status">{{'Encours'}}</vs-chip> 
        </vs-td>

        <vs-td v-if="getlang ==='en'" >
        <vs-chip v-if="tr.leadProjectValidation === 0" :color="getOrderStatusColor1(tr.leadProjectValidation)" class="product-order-status">{{'Rejected'}}</vs-chip> 
        <vs-chip v-if="tr.leadProjectValidation === 1" :color="getOrderStatusColor1(tr.leadProjectValidation)" class="product-order-status">{{'Validated'}}</vs-chip> 
        <vs-chip v-if="tr.leadProjectValidation === 2" :color="getOrderStatusColor1(tr.leadProjectValidation)" class="product-order-status">{{'Verification'}}</vs-chip> 
        </vs-td>

          <vs-td class="whitespace-no-wrap">
            <div v-if="tr.jobRiskAssessmentStep === true" class="flex">
             <div class="flex">
             
              <vx-tooltip v-if="tr.missionComments.length" :text="$t('Voir')" color="warning">
                <feather-icon
                  style="color: darkgoldenrod"
                  icon="EyeIcon"
                  svgClasses="w-5 h-5 hover:text-warning stroke-current"
                  class="mr-2"
                  @click="show_comment(tr)"
                />
              </vx-tooltip>

              <vx-tooltip :text="$t('Valider')" color="primary">
                <feather-icon
                  @click="show_mission_open(tr)"
                  style="color: blue"
                  icon="CheckSquareIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  class="mr-2"
                />
              </vx-tooltip>

             </div>
            </div>
          </vs-td>
        </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <!-- fullscreen -->
    <vs-popup
      v-if="show_mission" 
        fullscreen
        class="calendar-event-dialog"
        title="Résumé de la mission"
        :active.sync="show_mission">
        <div class="clearfix">
          <div class="p-base">
              <div Align="Center"><h4 class="font-semibold"><U>RÉSUMÉ MISSION ( {{ ref_mission }} ) </U></h4></div>
              <br>
              <p>
                <span class="font-semibold mr-2">1. Projet : </span><span class="mr-2">
                    {{ projet_ref }}
                </span>
              </p>
              <br>
              <p>
                <span class="font-semibold mr-2">2. Sites ({{ site_number}}) :</span><span class="mr-2">
                   {{ site_name }}
                </span>
              </p>
              <br>
              <p>
                <span class="font-semibold mr-2">3. Tâches :</span><span class="mr-2">
                   {{ tache_name }}
                </span>
              </p>
              <br>
              <p>
                <span class="font-semibold mr-2">4. Profil de risque  :</span><span class="mr-2">
                   {{ profile_risque_name }}
                </span>
              </p>
              <br>
              <p>
                <span class="font-semibold mr-2">5. Équipe :</span><span class="mr-2">
                   ( {{equipe_persone_valide}} ) personne(s) validée(s)
                </span>
              </p>
              <br>
              <p>
                <span class="font-semibold mr-2">6. Outils :</span><span class="mr-2">
                    {{outils}}
                </span>
              </p>
              <br>
              <p>
                <span class="font-semibold mr-2">7. Date prévisionnelle :</span><span class="mr-2">
                   {{ date_previsiionnelle }}
                </span>
              </p>
              <br>
              <p>
                <span class="font-semibold mr-2">8. Véhicules :</span><span class="mr-2">
                   {{ vehicule }}
                </span>
              </p>
              <br>
              <p>
                <span class="font-semibold mr-2">9. Longueur du trajet :</span><span class="mr-2">
                    {{  distance_tajet }} ,( {{ number_pause }} ) pause(s) ,{{ ville_pause_tajet }}
                </span>
              </p>
              <br>
              <p>
                <span class="font-semibold mr-2">10. Évaluation des zones d'exclusions :</span><span class="mr-2">
                  {{evalutionRiskObject[evaluation_zone]}}
                 </span>
              </p>
              <br>
              <p>
                <span class="font-semibold mr-2">11. Évaluation de risques :</span><span class="mr-2">
                   {{ evalution_risque }}     
               </span>
              </p>
              <br>
              <p>
                <span class="font-semibold mr-2">12. Statut des validations :</span><span class="mr-2">
                    {{ statut_validation }}
                </span>
              </p>
            </div>
        </div>
        <div v-if="user_role === 'admin'" class="flex ">

        <div class="flex flex-wrap justify-between" v-if="leadProjectValidation_action === 2">
        <div v-if="user_role === 'admin' && pessNokiaValidation_action === 2" >
          <vs-button :disabled="pessNokiaValidation_action === 1" color="success"  class="float-right mt-4 mr-4" @click="validerMission_PessNokia(id_mission)" >Valider (Pess nokia)</vs-button>
          <vs-button :disabled="pessNokiaValidation_action === 0" color="danger"  class="float-right mt-4 mr-4" @click="RejeterMission_PessNokia(id_mission)" >Rejeter (Pess nokia)</vs-button>
        </div>
        
        <div v-if="user_role === 'admin' && pessNokiaValidation_action !== 2 && leadProjectValidation_action !==2" >
          <vs-button :disabled="pessNokiaValidation_action === 1" color="success"  class="float-right mt-4 mr-4" @click="validerMission_PessNokia(id_mission)" >Valider (Pess nokia)</vs-button>
          <vs-button :disabled="pessNokiaValidation_action === 0" color="danger"  class="float-right mt-4 mr-4" @click="RejeterMission_PessNokia(id_mission)" >Rejeter (Pess nokia)</vs-button>
        </div>

        <div v-if="user_role === 'admin' && pessNokiaValidation_action === 1 && leadProjectValidation_action !==2 " >
          <vs-button :disabled="qhsNokiaValidation_action === 1" color="success"  class="float-right mt-4 mr-4" @click="validerMission_QshNokia(id_mission)" >Valider (Qsh nokia)</vs-button>
          <vs-button :disabled="qhsNokiaValidation_action === 0" color="danger"  class="float-right mt-4 mr-4" @click="RejeterMission_QshNokia(id_mission)" >Rejeter (Qsh nokia)</vs-button>
        </div>

       
        <div v-if="user_role === 'admin' && qhsNokiaValidation_action === 1 " >
          <vs-button :disabled="leadProjectValidation_action === 1"  color="success"  class="float-right mt-4 mr-4" @click="validerMission_LeadProject(id_mission)" >Valider (Chef projet)</vs-button>
          <vs-button :disabled="leadProjectValidation_action === 0"  color="danger"  class="float-right mt-4 mr-4" @click="RejeterMission_LeadProject(id_mission)" >Rejeter (Chef projet)</vs-button>
        </div>
        </div>

        <div class="flex flex-wrap justify-between" v-if="leadProjectValidation_action !== 2">
        
        <div v-if="user_role === 'admin' && qhsNokiaValidation_action === 0 && leadProjectValidation_action === 0 " >
          <vs-button :disabled="pessNokiaValidation_action === 1" color="success"  class="float-right mt-4 mr-4" @click="validerMission_PessNokia(id_mission)" >Valider (Pess nokia)</vs-button>
          <vs-button :disabled="pessNokiaValidation_action === 0" color="danger"  class="float-right mt-4 mr-4" @click="RejeterMission_PessNokia(id_mission)" >Rejeter (Pess nokia)</vs-button>
        </div>

        <div v-if="user_role === 'admin' && pessNokiaValidation_action === 1 && leadProjectValidation_action === 0  " >
          <vs-button :disabled="qhsNokiaValidation_action === 1" color="success"  class="float-right mt-4 mr-4" @click="validerMission_QshNokia(id_mission)" >Valider (Qsh nokia)</vs-button>
          <vs-button :disabled="qhsNokiaValidation_action === 0" color="danger"  class="float-right mt-4 mr-4" @click="RejeterMission_QshNokia(id_mission)" >Rejeter (Qsh nokia)</vs-button>
        </div>

       
        <div v-if="user_role === 'admin'&& qhsNokiaValidation_action === 1 && pessNokiaValidation_action === 1 " >
          <vs-button :disabled="leadProjectValidation_action === 1"  color="success"  class="float-right mt-4 mr-4" @click="validerMission_LeadProject(id_mission)" >Valider (Chef projet)</vs-button>
          <vs-button :disabled="leadProjectValidation_action === 0"  color="danger"  class="float-right mt-4 mr-4" @click="RejeterMission_LeadProject(id_mission)" >Rejeter (Chef projet)</vs-button>
        </div>
        
        </div>

        </div>
        
        <div v-if="user_role !== 'admin'">

        <div  v-if="leadProjectValidation_action ===2" >

        <div v-if="user_role === 'pessNokia' && pessNokiaValidation_action === 2" >
          <vs-button :disabled="pessNokiaValidation_action === 1" color="success"  class="float-right mt-4 mr-4" @click="validerMission_PessNokia(id_mission)" >Valider (Pess nokia)</vs-button>
          <vs-button :disabled="pessNokiaValidation_action === 0" color="danger"  class="float-right mt-4 mr-4" @click="RejeterMission_PessNokia(id_mission)" >Rejeter (Pess nokia)</vs-button>
        </div>

        <div v-if="user_role === 'pessNokia' && pessNokiaValidation_action !== 2 && leadProjectValidation_action ===2 " >
          <vs-button :disabled="pessNokiaValidation_action === 1" color="success"  class="float-right mt-4 mr-4" @click="validerMission_PessNokia(id_mission)" >Valider (Pess nokia)</vs-button>
          <vs-button :disabled="pessNokiaValidation_action === 0" color="danger"  class="float-right mt-4 mr-4" @click="RejeterMission_PessNokia(id_mission)" >Rejeter (Pess nokia)</vs-button>
        </div>

    
         <div v-if="user_role === 'qhsNokia' && pessNokiaValidation_action === 1 && leadProjectValidation_action ===2 ">
          <vs-button :disabled="qhsNokiaValidation_action === 1" color="success"  class="float-right mt-4 mr-4" @click="validerMission_QshNokia(id_mission)" >Valider (Qsh nokia)</vs-button>
          <vs-button :disabled="qhsNokiaValidation_action === 0" color="danger"  class="float-right mt-4 mr-4" @click="RejeterMission_QshNokia(id_mission)" >Rejeter (Qsh nokia)</vs-button>
         </div>

         <div v-if="user_role === 'leadProject' && qhsNokiaValidation_action === 1  ">
          <vs-button :disabled="leadProjectValidation_action === 1"  color="success"  class="float-right mt-4 mr-4" @click="validerMission_LeadProject(id_mission)" >Valider (Chef projet)</vs-button>
          <vs-button :disabled="leadProjectValidation_action === 0"  color="danger"  class="float-right mt-4 mr-4" @click="RejeterMission_LeadProject(id_mission)" >Rejeter (Chef projet)</vs-button>
         </div>
        </div>

        <div  v-if="leadProjectValidation_action !==2" >
  
          <div v-if="user_role === 'pessNokia' && qhsNokiaValidation_action === 0" >
            <vs-button :disabled="pessNokiaValidation_action === 1" color="success"  class="float-right mt-4 mr-4" @click="validerMission_QshNokia(id_mission)" >Valider (Pess nokia)</vs-button>
            <vs-button :disabled="pessNokiaValidation_action === 0" color="danger"  class="float-right mt-4 mr-4" @click="RejeterMission_QshNokia(id_mission)" >Rejeter (Pess nokia)</vs-button>
          </div>
  
      
           <div v-if="user_role === 'qhsNokia' && leadProjectValidation_action === 0 ">
            <vs-button :disabled="qhsNokiaValidation_action === 1" color="success"  class="float-right mt-4 mr-4" @click="validerMission_PessNokia(id_mission)" >Valider (Qsh nokia)</vs-button>
            <vs-button :disabled="qhsNokiaValidation_action === 0" color="danger"  class="float-right mt-4 mr-4" @click="RejeterMission_PessNokia(id_mission)" >Rejeter (Qsh nokia)</vs-button>
           </div>
  
           <div v-if="user_role === 'leadProject' && qhsNokiaValidation_action === 1  ">
            <vs-button :disabled="leadProjectValidation_action === 1"  color="success"  class="float-right mt-4 mr-4" @click="validerMission_LeadProject(id_mission)" >Valider (Chef projet)</vs-button>
            <vs-button :disabled="leadProjectValidation_action === 0"  color="danger"  class="float-right mt-4 mr-4" @click="RejeterMission_LeadProject(id_mission)" >Rejeter (Chef projet)</vs-button>
           </div>
        </div>
        
        </div>
    </vs-popup>

    <vs-popup classContent="popup-example" :title="$t('ajouter_votre_commentaire_QHS')" :active.sync="activePrompt2">
      <vs-textarea
        v-model="comment"
        rows="5"
        class="w-full" >
      </vs-textarea>
      <div class="flex flex-wrap justify-between mt-5 ">
      <vs-button   color="danger" type="filled" icon-pack="feather" icon="icon-minus-circle" @click="resetData_comfirmation">{{$t("Annuler")}}</vs-button>
      <vs-button  :disabled="!validate_comment" color="success" type="filled" icon-pack="feather" icon="icon-plus-circle" @click="RejeterMission_QshNokia_valider">Valider</vs-button>
      </div>
    </vs-popup>

    <vs-popup classContent="popup-example" :title="$t('ajouter_votre_commentaire_PESS')" :active.sync="activePrompt3">
      <vs-textarea
        v-model="comment"
        rows="5"
        class="w-full" >
      </vs-textarea>
      <div class="flex flex-wrap justify-between mt-5 ">
      <vs-button   color="danger" type="filled" icon-pack="feather" icon="icon-minus-circle" @click="resetData_comfirmation">{{$t("Annuler")}}</vs-button>
      <vs-button  :disabled="!validate_comment" color="success" type="filled" icon-pack="feather" icon="icon-plus-circle" @click="RejeterMission_PessNokia_valider">Valider</vs-button>
      </div>
    </vs-popup>

    <vs-popup classContent="popup-example" :title="$t('ajouter_votre_commentaire_CHEF')" :active.sync="activePrompt4">
      <vs-textarea
        v-model="comment"
        rows="5"
        class="w-full" >
      </vs-textarea>
      <div class="flex flex-wrap justify-between mt-5 ">
      <vs-button   color="danger" type="filled" icon-pack="feather" icon="icon-minus-circle" @click="resetData_comfirmation">{{$t("Annuler")}}</vs-button>
      <vs-button  :disabled="!validate_comment" color="success" type="filled" icon-pack="feather" icon="icon-plus-circle" @click="RejeterMission_LeadProject_valider">Valider</vs-button>
      </div>
    </vs-popup>
    
    
    <vs-popup classContent="popup-example" :title="$t('details_du_rejet')" :active.sync="activePrompt5">
      
      <li class="mb-2" v-for="comment in comment" :key="comment" >{{ comment.comment}}</li>

    </vs-popup>

    <div  class="flex flex-wrap justify-between my-5" >
      <vs-button  :disabled="pageCount === 1"  v-if="this.repPrev !== null" @click="prev()" class="ml-4 mb-4">Précédent</vs-button>
      <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">Page({{ pageCount }}) / Page({{ countPages }})</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
              <vs-dropdown-menu  class="dropdown-scroll">
              <vs-dropdown-item
                v-for="n in countPages"
                :key="n"
                @click="paginationAllMissions(n)"
              >
                <span>{{ n }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
      <vs-button  :disabled="pageCount === pageTotal"  v-if="this.repNext !== null" @click="next()" class="ml-4 mb-4" >Suivant</vs-button>
      </div>
  </div>
  
  </template>
<script>
const str = 'https://dev.jra.mitigarisk.com/api/'
export default {
  data () {
    return {
      pageTotal:1,
      pageCount:1,
      count:0,
      id_mission : '',
      activePrompt2:false,
      activePrompt3:false,
      activePrompt4:false,
      activePrompt5:false,

      comment:'',
      mission_id:'',

      qhsNokiaValidation_action:false,
      pessNokiaValidation_action:false,
      leadProjectValidation_action:false,

      ref_mission:'',
      projet_ref:'',
      site_number:'',
      site_name:'',
      tache_name:'',
      profile_risque_name:'',
      equipe_persone_valide:'',
      outils : '',
      date_previsiionnelle:'',
      vehicule:'',
      distance_tajet:'',
      ville_pause_tajet:'',
      number_pause:'',
      evaluation_zone:'',
      evalution_risque:'',
      statut_validation:'',
      show_mission : false,
     
      evalutionRiskObject: {
        red: 'Point critiques à considérer',
        orange: 'Point de virgilance à considérer',
        green:'Rien à signaler'
      },
      evalutionRiskObject_en: {
        red: 'Critical points to consider',
        orange: 'Virgilance point to consider',
        green:'Nothing to report'
      },
      produits_computed_show : [],
      activePrompt1 : '',
      user_role : '',
      missions:[],
      objResult:[],
      isMounted: false,
      itemsPerPage: 20
    }
  },
  watch: {
    count (newVal) {
      if (this.isMounted && newVal > 3) {
        this.pageTotal = Math.ceil(newVal / 3)
      } else {
        this.pageTotal = 1
      }
    }
  },
  computed: {
    getlang () {
      return window.getPrendTaCom.$i18n.locale
    },
    validate_comment () {
      if (
        (
          this.comment !== ''  
        )) return true
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.missions.length
    },
    countPages () {
      if (this.isMounted && this.count > 3) {
        return Math.ceil(this.count / 3)
      }
      return 1
    },
    countPagesResulte () {
      if (this.count > 3) {
        return true
      }
      return false
    }
  },
  methods: {
    next () {
      this.$vs.loading()
      this.$http.get(this.repNext)
        .then((response) => {
          this.countNext()
          this.count = 0
          this.objResult = []
          let finale_color = ''
          let stat_yellow = ''
          let stat_red = ''
          const obj_mission_Risk = {
            id_mission : [],
            danger_obj : []
          }
          const obj_mission_Risk_end = {
            id_mission_end : [],
            danger_obj_end : []
          }
          this.missions = response.data.results
          const results = this.missions
          this.missions = response.data.results
          this.count = response.data.count
          this.repNext = response.data.next ? str + response.data.next.substr(34) : null
          this.repPrev = response.data.previous ? str + response.data.previous.substr(34) : null
          results.forEach(event => {
            if (event.missionRiskZoneAssessment.length) {
              obj_mission_Risk.id_mission.push(event.id)
              obj_mission_Risk.danger_obj.push(event.missionRiskZoneAssessment[0].questionHasFileHasSites)
            }
          
          })
          if (obj_mission_Risk.id_mission.length) {
            for (let i = 0; i < obj_mission_Risk.id_mission.length; i++) {
              this.danger_obj_end = []
              const risk_obj = obj_mission_Risk.danger_obj[i]
              risk_obj.forEach(event => {
                const obj = {
                  mission_id : obj_mission_Risk.id_mission[i],
                  conditionFaux:event.conditionFaux,
                  conditionNa:event.conditionNa,
                  conditionVrai:event.conditionVrai,
                  colorVrai:event.question.colorVrai,
                  //colorNa:event.question.colorNa,
                  colorFaux:event.question.colorFaux,
                  description:event.question.description,
                  site_name:event.site.name
                  //question:event.question,
                  //site:event.site
                } 
                this.danger_obj_end.push(obj)
              })  
              obj_mission_Risk_end.id_mission_end.push(obj_mission_Risk.id_mission[i])  
              obj_mission_Risk_end.danger_obj_end.push(this.danger_obj_end)          
            }
            
          }
          if (obj_mission_Risk_end.id_mission_end.length) {
            for (let t = 0; t < obj_mission_Risk_end.id_mission_end.length; t++) {
              const obj_normale = {
                mission_id :'',
                valeurColor : ''
              } 
              
              let couleurFaux_red = 0
              let couleurFaux_yellow = 0
              let couleurVrai_red = 0
              let couleurVrai_yellow = 0


              for (let y = 0; y < obj_mission_Risk_end.danger_obj_end.length; y++) {
                const obj_var = obj_mission_Risk_end.danger_obj_end[y]
                for (let z = 0; z < obj_var.length; z++) {
                  if (obj_mission_Risk_end.id_mission_end[t] === obj_var[z].mission_id) {

                    if (obj_var[z].conditionFaux === true) {
                      //countFaux++
                      if (obj_var[z].colorFaux === 'yellow') {
                        couleurFaux_yellow++
                      }
                      if (obj_var[z].colorFaux === 'red') {
                        couleurFaux_red++
                      }
                    }

                    if (obj_var[z].conditionVrai === true) {
                      //countVrai++
                      if (obj_var[z].colorVrai === 'yellow') {
                        couleurVrai_yellow++
                      }
                      if (obj_var[z].colorVrai === 'red') {
                        couleurVrai_red++
                      }
                    } 
                  }
                }
                
              }
              stat_yellow = couleurFaux_yellow + couleurVrai_yellow
              stat_red =  couleurFaux_red + couleurVrai_red

              if (stat_yellow < stat_red) {
                finale_color = 'red'
              } else if (stat_red < stat_yellow) {
                //yellow
                finale_color = '#F8B62C'
              } else if (stat_red === stat_yellow) {
                finale_color = 'red'
              } else if (stat_red === 0 && stat_yellow === 0) {
                finale_color = 'green'
              } else if (stat_red === 0 && stat_yellow > 1) {
                //yellow
                finale_color = '#F8B62C'
              } else {
                finale_color = 'red'
              }      
              obj_normale.mission_id = obj_mission_Risk_end.id_mission_end[t]
              obj_normale.valeurColor = finale_color
              this.objResult.push(obj_normale)
            }
          }
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    prev () {
      this.$vs.loading()
      this.$http.get(this.repPrev)
        .then((response) => {
          this.countPrev()
          this.count = 0
          this.objResult = []
          let finale_color = ''
          let stat_yellow = ''
          let stat_red = ''
          const obj_mission_Risk = {
            id_mission : [],
            danger_obj : []
          }
          const obj_mission_Risk_end = {
            id_mission_end : [],
            danger_obj_end : []
          }
          this.missions = response.data.results
          const results = this.missions
          this.count = response.data.count
          this.repNext = response.data.next ? str + response.data.next.substr(34) : null
          this.repPrev = response.data.previous ? str + response.data.previous.substr(34) : null
          results.forEach(event => {
            if (event.missionRiskZoneAssessment.length) {
              obj_mission_Risk.id_mission.push(event.id)
              obj_mission_Risk.danger_obj.push(event.missionRiskZoneAssessment[0].questionHasFileHasSites)
            }
          
          })
          if (obj_mission_Risk.id_mission.length) {
            for (let i = 0; i < obj_mission_Risk.id_mission.length; i++) {
              this.danger_obj_end = []
              const risk_obj = obj_mission_Risk.danger_obj[i]
              risk_obj.forEach(event => {
                const obj = {
                  mission_id : obj_mission_Risk.id_mission[i],
                  conditionFaux:event.conditionFaux,
                  conditionNa:event.conditionNa,
                  conditionVrai:event.conditionVrai,
                  colorVrai:event.question.colorVrai,
                  //colorNa:event.question.colorNa,
                  colorFaux:event.question.colorFaux,
                  description:event.question.description,
                  site_name:event.site.name
                  //question:event.question,
                  //site:event.site
                } 
                this.danger_obj_end.push(obj)
              })  
              obj_mission_Risk_end.id_mission_end.push(obj_mission_Risk.id_mission[i])  
              obj_mission_Risk_end.danger_obj_end.push(this.danger_obj_end)          
            }
            
          }
          if (obj_mission_Risk_end.id_mission_end.length) {
            for (let t = 0; t < obj_mission_Risk_end.id_mission_end.length; t++) {
              const obj_normale = {
                mission_id :'',
                valeurColor : ''
              } 
              
              let couleurFaux_red = 0
              let couleurFaux_yellow = 0
              let couleurVrai_red = 0
              let couleurVrai_yellow = 0


              for (let y = 0; y < obj_mission_Risk_end.danger_obj_end.length; y++) {
                const obj_var = obj_mission_Risk_end.danger_obj_end[y]
                for (let z = 0; z < obj_var.length; z++) {
                  if (obj_mission_Risk_end.id_mission_end[t] === obj_var[z].mission_id) {

                    if (obj_var[z].conditionFaux === true) {
                      //countFaux++
                      if (obj_var[z].colorFaux === 'yellow') {
                        couleurFaux_yellow++
                      }
                      if (obj_var[z].colorFaux === 'red') {
                        couleurFaux_red++
                      }
                    }

                    if (obj_var[z].conditionVrai === true) {
                      //countVrai++
                      if (obj_var[z].colorVrai === 'yellow') {
                        couleurVrai_yellow++
                      }
                      if (obj_var[z].colorVrai === 'red') {
                        couleurVrai_red++
                      }
                    } 
                  }
                }
                
              }
              stat_yellow = couleurFaux_yellow + couleurVrai_yellow
              stat_red =  couleurFaux_red + couleurVrai_red

              if (stat_yellow < stat_red) {
                finale_color = 'red'
              } else if (stat_red < stat_yellow) {
                //yellow
                finale_color = '#F8B62C'
              } else if (stat_red === stat_yellow) {
                finale_color = 'red'
              } else if (stat_red === 0 && stat_yellow === 0) {
                finale_color = 'green'
              } else if (stat_red === 0 && stat_yellow > 1) {
                //yellow
                finale_color = '#F8B62C'
              } else {
                finale_color = 'red'
              }      
              obj_normale.mission_id = obj_mission_Risk_end.id_mission_end[t]
              obj_normale.valeurColor = finale_color
              this.objResult.push(obj_normale)
            }
          }
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    countNext () {
      if (this.pageTotal > this.pageCount) {
        if (this.pageCount <= this.count) { this.pageCount = this.pageCount + 1 }
      }
    },
    countPrev () {
      if (this.count > 2) {
        if (this.pageCount > 1) {
          this.pageCount = this.pageCount - 1
        }
      }
    },
    show_comment (tr) {
      this.comment = ''
      this.comment = tr.missionComments
      this.activePrompt5 = true
    },

    show_mission_open (tr) {
      this.id_mission = tr.id
      this.qhsNokiaValidation_action = tr.qhsNokiaValidation
      this.pessNokiaValidation_action = tr.pessNokiaValidation
      this.leadProjectValidation_action = tr.leadProjectValidation
      const transform = {0 :'Non validé', 1 :'Validé', 2 : 'Encours'}
      this.evalution_risque = 'Rien à signaler' 
      this.ref_mission = tr.poNumber
      this.projet_ref = tr.project.name
      this.site_number = tr.sites.length
      this.site_name = tr.sites.map(site => site.name).join(', ')
      this.tache_name = tr.tasks.map(task => task.name).join(', ')      
      this.profile_risque_name = tr.riskProfiles.map(riskProfile => riskProfile.name).join(', ')
      this.equipe_persone_valide = tr.team.staffs.filter(staff => staff.activated === 1).length
      const { compteurPoulie, compteurCorde, compteurSangle, compteurMousqueton, compteurBalise, compteurTreuil} = tr.team.liftingEquipments.reduce((acc, equipment) => {
        if (equipment.equipmentType.name === 'poulie') {
          acc.compteurPoulie++
        } else if (equipment.equipmentType.name === 'corde') {
          acc.compteurCorde++
        } else if (equipment.equipmentType.name === 'sangle') {
          acc.compteurSangle++
        } else if (equipment.equipmentType.name === 'mousqueton') {
          acc.compteurMousqueton++
        } else if (equipment.equipmentType.name === 'balise') {
          acc.compteurBalise++
        } else if (equipment.equipmentType.name === 'treuil') {
          acc.compteurTreuil++
        }
        return acc
      }, { compteurPoulie: 0, compteurCorde: 0, compteurSangle: 0, compteurMousqueton: 0, compteurBalise: 0, compteurTreuil: 0 })
      this.outils = `( ${compteurPoulie} ) Poulie(s) , ( ${compteurCorde} ) Corde(s) , ( ${compteurSangle} ) Sangles(s) ,
       ( ${compteurMousqueton} ) Mousqueton(s) , ( ${compteurBalise} ) Balise(s) , ( ${compteurTreuil} ) Treuil(s)`
      this.date_previsiionnelle = `Du ${tr.startDate} au ${tr.endDate}`
      const plaquesActives = tr.team.vehicles.reduce((acc, vehicle) => {
        if (vehicle.activated === 1) {
          acc.push(vehicle.plateNumber)
        }
        return acc
      }, [])
      this.vehicule = plaquesActives.join(', ')
      this.distance_tajet = `${tr.missionJourney[0].distance} km`
      this.ville_pause_tajet = tr.missionJourney[0].breacks.map(sites => sites.site).join(' et ')
      this.number_pause = tr.missionJourney[0].breacks.length
      this.statut_validation = `${transform[tr.qhsNokiaValidation]} QHS > ${ transform[tr.pessNokiaValidation]} PESS > ${ transform[tr.leadProjectValidation]} LEAD `
      this.evaluation_zone = this.getOrderMissionColor1(tr.id)
      this.jobRiskaverage(tr.missionJobRiskAssessment[0].jobRiskAssessmentHasRisks)
      this.produits_computed_show.forEach(item => { 
        if (item.residualRisk >= 15) { 
          this.evalution_risque = 'Point de vigilance' 
        }
      })
      this.show_mission = true
    },
    jobRiskaverage (data) {
      this.produits_computed_show = []
      this.repProduit = []
      const z = data.length
      for (let i = 0; i < z; i++) {
        const obj = {          
          residualRisk: ''
        }
        obj.residualRisk = data[i].residualRisk
        this.repProduit.push(obj)
      }
      for (let j = 0; j <  this.repProduit.length; j++) {
        this.produits_computed_show.push(this.repProduit[j])
      }
    },
    carte (id) {
      this.$http.get(`generate_mission_url/${id}/`)
        .then(response => {
          const url = response.data.url
          window.open(url, '_blank')
        })
        .catch(() => {
          this.$vs.notify({
            time: 4000,
            title: 'ATTENTION',
            text: this.$t('opération_échouée'),
            color: 'warning',
            position: 'top-center'
          })       
        })
    },
    getOrderMissionColor (status) {
      const obj = this.objResult.find(item => item.mission_id === status)
      return obj ? obj.valeurColor : null
    },

    getOrderMissionColor1 (status) {
      const obj = this.objResult.find(item => item.mission_id === status)
      return obj ? obj.valeurColor : null
    },

    getOrderStatusColor (status) {
      if (status === false) {
        return 'warning'
      } else if (status === true) {
        return 'success'
      } else {
        return 'danger'

      } 
    },
    getOrderStatusColor1 (status) {
      if (status === 0) {
        return 'danger'
      } else if (status === 1) {
        return 'success'
      } else if (status === 2) {
        return 'warning'
      }
    },
    planification () {
      this.$router.push('/Planifications').catch(() => {})
    },
    missionStep () {
      this.missionControle = 2
      this.activePrompt1_mission = 1
      this.$router.push('/MissionPlanifications').catch(() => {})
    },
    missionStep_show (tr) {
      this.$http.get(`missions/${tr.id}/`)
        .then(response => {
          this.planification_mission_data = response.data
          this.missionControle = 2
          this.activePrompt1_mission = 2
          this.$router.push('/MissionPlanifications').catch(() => {})
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
      //this.planification_mission_data = JSON.parse(JSON.stringify(tr))
    },
    missionStep_editData (tr) {
      this.$http.get(`missions/${tr.id}/`)
        .then(response => {
          this.planification_mission_data = response.data
          this.missionControle = 2
          this.activePrompt1_mission = 3
          this.$router.push('/MissionPlanifications').catch(() => {})
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    missionStep_confirmation_show (tr) {
      this.$http.get(`missions/${tr.id}/`)
        .then(response => {
          this.missionControle = 2
          this.activePrompt1_mission = 4
          this.planification_mission_data = response.data
          this.$router.push('/MissionPlanifications').catch(() => {})
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    journeyStep (tr) {
      this.missionControle = 2
      this.activePrompt1_journey = 1
      this.planification_mission_data = JSON.parse(JSON.stringify(tr))
      this.$router.push('/MissionJourneys').catch(() => {})
    },
    journeyStep_show (tr) {
      this.$http.get(`journeys/${tr.missionJourney[0].id}/`)
        .then(response => {
          this.missionControle = 2
          this.activePrompt1_journey = 2
          this.planification_mission_data = response.data
          this.$router.push('/MissionJourneys').catch(() => {})
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    journeyStep_editData (tr) {
      this.$http.get(`journeys/${tr.missionJourney[0].id}/`)
        .then(response => {
          this.missionControle = 2
          this.activePrompt1_journey = 3
          this.planification_mission_data = response.data
          this.$router.push('/MissionJourneys').catch(() => {})
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    journeyStep_plus (tr) {
      this.$http.get(`journeys/${tr.missionJourney[0].id}/`)
        .then(response => {
          this.missionControle = 2
          this.activePrompt1_journey = 4
          this.planification_mission_data = response.data
          this.$router.push('/MissionJourneys').catch(() => {})
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    evacuationPlanStep (tr) {
      this.missionControle = 2
      this.activePrompt1_journey = 1
      this.planification_mission_data = JSON.parse(JSON.stringify(tr))
      this.$router.push('/MissionEvacuations').catch(() => { })
      
    },
    evacuationPlanStep_show (tr) {
      this.$http.get(`evacuationPlans/${tr.missionEvacuationPlan[0].id}/`)
        .then(response => {
          this.missionControle = 2
          this.activePrompt1_journey = 2
          this.planification_mission_data = response.data
          this.$router.push('/MissionEvacuations').catch(() => {})
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    evacuationPlanStep_editData (tr) {
      this.$http.get(`evacuationPlans/${tr.missionEvacuationPlan[0].id}/`)
        .then(response => {
          this.missionControle = 2
          this.activePrompt1_journey = 3
          this.planification_mission_data = response.data
          this.$router.push('/MissionEvacuations').catch(() => {})
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    riskZoneAssessmentStep (tr) {
      this.missionControle = 2
      this.activePrompt1_journey = 1
      this.planification_mission_data = JSON.parse(JSON.stringify(tr))
      this.$router.push('/MissionRiskZones')
    },
    riskZoneAssessmentStep_show (tr) {
      this.$http.get(`riskZoneAssessments/${tr.missionRiskZoneAssessment[0].id}/`)
        .then(response => {
          this.missionControle = 2
          this.activePrompt1_journey = 2
          this.planification_mission_data = response.data
          this.$router.push('/MissionRiskZones').catch(() => {})
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    riskZoneAssessmentStep_editData (tr) {
      this.$http.get(`riskZoneAssessments/${tr.missionRiskZoneAssessment[0].id}/`)
        .then(response => {
          this.missionControle = 2
         
          this.activePrompt1_journey = 3
          this.planification_mission_data = response.data
          this.$router.push('/MissionRiskZones').catch(() => {})
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    jobRiskAssessmentStep (tr) {
      this.missionControle = 2
      this.activePrompt1_journey = 1
      this.planification_mission_data = JSON.parse(JSON.stringify(tr))
      this.$router.push('/MissionJobRiskAssessments').catch(() => {})
    },
    jobRiskAssessmentStep_show (tr) {
      
      this.$http.get(`jobRiskAssessments/${tr.missionJobRiskAssessment[0].id}/`)
        .then(response => {
          this.missionControle = 2
          this.activePrompt1_journey = 2
          this.planification_mission_data = response.data
          this.$router.push('/MissionJobRiskAssessments').catch(() => { })
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    jobRiskAssessmentStep_editData (tr) {
     
      this.$http.get(`jobRiskAssessments/${tr.missionJobRiskAssessment[0].id}/`)
        .then(response => {
          this.missionControle = 2
          this.activePrompt1_journey = 3
          this.planification_mission_data = response.data
          this.$router.push('/MissionJobRiskAssessments').catch(() => { })
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    jobRiskAssessmentStep_ValidateData (tr) {
      
      this.$http.get(`jobRiskAssessments/${tr.missionJobRiskAssessment[0].id}/`)
        .then(response => {
          this.missionControle = 2
          this.activePrompt1_journey = 4
          this.planification_mission_data = response.data
          this.$router.push('/MissionJobRiskAssessments').catch(() => { })
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    evalutionSecurityStep_show (tr) {
      this.$http.get(`securityThreatEvaluations/${tr.missionSecurityThreatEvaluations[0].id}/`)
        .then(response => {
          this.missionControle = 2
          this.activePrompt1_EvalutionSecurity = 5
          this.planification_mission_data = response.data
          this.$router.push('/MissionEvalutionSecurity').catch(() => { })
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          
        })
    },
    addNewData_mission () {
      this.missionStep()
    },
 
    validerMission_QshNokia (mission) {
      this.show_mission = false
      this.$vs.dialog({
        type:'confirm',
        color: 'success',
        title: 'Confirmation mission',
        text: 'Confirmer la validation de la mission?',
        acceptText: 'Confirmer',
        cancelText: 'Annuler',
        accept: async () => {
          this.$vs.loading()
          this.$http.post('qhs-validate-mission/', {mission})
            .then(response => {
              this.getAllMissions()
              this.show_mission = false
              window.getPrendTaCom.success('Mission comfirmée', response)
            })
            .catch(() => {
              window.getPrendTaCom.error({ message: 'échoué.' })
            })
        }
      })

    },
    validerMission_PessNokia (mission) {
      this.show_mission = false
      this.$vs.dialog({
        type:'confirm',
        color: 'success',
        title: 'Confirmation mission',
        text: 'Confirmer la validation de la mission?',
        acceptText: 'Confirmer',
        cancelText: 'Annuler',
        accept: async () => {
          this.$vs.loading()
          this.$http.post('pess-validate-mission/', {mission})
            .then(response => {
              this.getAllMissions()
              this.show_mission = false
              window.getPrendTaCom.success('Mission validée', response)
            })
            .catch(() => {
              window.getPrendTaCom.error({ message: 'échoué.' })
            })
        }
      })

    },
    validerMission_LeadProject (mission) {
      this.show_mission = false
      this.$vs.dialog({
        type:'confirm',
        color: 'success',
        title: 'Confirmation mission',
        text: 'Confirmer la validation de la mission?',
        acceptText: 'Confirmer',
        cancelText: 'Annuler',
        accept: async () => {
          this.$vs.loading()
          this.$http.post('leadProject-validate-mission/', {mission})
            .then(response => {
              this.getAllMissions()
              this.show_mission = false
              window.getPrendTaCom.success('Mission validée', response)
            })
            .catch(() => {
              window.getPrendTaCom.error({ message: 'échoué.' })
            })
        }
      })

    },

    RejeterMission_QshNokia (mission) {
      this.comment = ''
      this.show_mission = false
      this.activePrompt2 = true
      this.mission_id = mission
    },

    RejeterMission_QshNokia_valider () {
      const mission = this.mission_id
      const comment = this.comment
      this.activePrompt2 = false
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Rejet mission',
        text: 'Confirmer le rejet de la mission?',
        acceptText: 'Confirmer',
        cancelText: 'Annuler',
        accept: async () => {
          this.$vs.loading()
          this.$http.post('qhs-reject-mission/', {mission, comment})
            .then(response => {
              this.getAllMissions()
              this.show_mission = false
              window.getPrendTaCom.success('Mission rejetée', response)
            })
            .catch(() => {
              window.getPrendTaCom.error({ message: 'échoué.' })
            })
        }
      })
    },

    RejeterMission_PessNokia (mission) {
      this.comment = ''
      this.show_mission = false
      this.activePrompt3 = true
      this.mission_id = mission
    },

    RejeterMission_PessNokia_valider () {
      const mission = this.mission_id
      const comment = this.comment
      this.activePrompt3 = false
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Rejet mission',
        text: 'Confirmer le rejet de la mission?',
        acceptText: 'Confirmer',
        cancelText: 'Annuler',
        accept: async () => {
          this.$vs.loading()
          this.$http.post('pess-reject-mission/', {mission, comment})
            .then(response => {
              this.getAllMissions()
              this.show_mission = false
              window.getPrendTaCom.success('Mission rejetée', response)
            })
            .catch(() => {
              window.getPrendTaCom.error({ message: 'échoué.' })
            })
        }
      })
    },

    RejeterMission_LeadProject (mission) {
      this.comment = ''
      this.show_mission = false
      this.activePrompt4 = true
      this.mission_id = mission
    },

    RejeterMission_LeadProject_valider () {
      const mission = this.mission_id
      const comment = this.comment
      this.activePrompt4 = false
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Rejet mission',
        text: 'Confirmer le rejet de la mission?',
        acceptText: 'Confirmer',
        cancelText: 'Annuler',
        accept: async () => {
          this.$vs.loading()
          this.$http.post('leadProject-reject-mission/', {mission, comment})
            .then(response => {
              this.getAllMissions()
              this.show_mission = false
              window.getPrendTaCom.success('Mission rejetée', response)
            })
            .catch(() => {
              window.getPrendTaCom.error({ message: 'échoué.' })
            })
        }
      })
    },

    getAllMissions () {
      this.search = ''
      this.$vs.loading()
      this.$http.get('paginated-missions/?page=1&per_page=3')
        .then((response) => {
          this.objResult = []
          let finale_color = ''
          let stat_yellow = ''
          let stat_red = ''
          const obj_mission_Risk = {
            id_mission : [],
            danger_obj : []
          }
          const obj_mission_Risk_end = {
            id_mission_end : [],
            danger_obj_end : []
          }
          
          this.missions = response.data.results
          const results = response.data.results
          this.pageCount = 1
          this.count = response.data.count
          this.repNext = str + (response.data.next).substr(34)
          this.repPrev = response.data.previous
          results.forEach(event => {
            if (event.missionRiskZoneAssessment.length) {
              obj_mission_Risk.id_mission.push(event.id)
              obj_mission_Risk.danger_obj.push(event.missionRiskZoneAssessment[0].questionHasFileHasSites)
            }
          
          })
          if (obj_mission_Risk.id_mission.length) {
            for (let i = 0; i < obj_mission_Risk.id_mission.length; i++) {
              this.danger_obj_end = []
              const risk_obj = obj_mission_Risk.danger_obj[i]
              risk_obj.forEach(event => {
                const obj = {
                  mission_id : obj_mission_Risk.id_mission[i],
                  conditionFaux:event.conditionFaux,
                  conditionNa:event.conditionNa,
                  conditionVrai:event.conditionVrai,
                  colorVrai:event.question.colorVrai,
                  //colorNa:event.question.colorNa,
                  colorFaux:event.question.colorFaux,
                  description:event.question.description,
                  site_name:event.site.name
                  //question:event.question,
                  //site:event.site
                } 
                this.danger_obj_end.push(obj)
              })  
              obj_mission_Risk_end.id_mission_end.push(obj_mission_Risk.id_mission[i])  
              obj_mission_Risk_end.danger_obj_end.push(this.danger_obj_end)          
            }
            
          }
          if (obj_mission_Risk_end.id_mission_end.length) {
            for (let t = 0; t < obj_mission_Risk_end.id_mission_end.length; t++) {
              const obj_normale = {
                mission_id :'',
                valeurColor : ''
              } 
              
              let couleurFaux_red = 0
              let couleurFaux_yellow = 0
              let couleurVrai_red = 0
              let couleurVrai_yellow = 0


              for (let y = 0; y < obj_mission_Risk_end.danger_obj_end.length; y++) {
                const obj_var = obj_mission_Risk_end.danger_obj_end[y]
                for (let z = 0; z < obj_var.length; z++) {
                  if (obj_mission_Risk_end.id_mission_end[t] === obj_var[z].mission_id) {

                    if (obj_var[z].conditionFaux === true) {
                      //countFaux++
                      if (obj_var[z].colorFaux === 'yellow') {
                        couleurFaux_yellow++
                      }
                      if (obj_var[z].colorFaux === 'red') {
                        couleurFaux_red++
                      }
                    }

                    if (obj_var[z].conditionVrai === true) {
                      //countVrai++
                      if (obj_var[z].colorVrai === 'yellow') {
                        couleurVrai_yellow++
                      }
                      if (obj_var[z].colorVrai === 'red') {
                        couleurVrai_red++
                      }
                    } 
                  }
                }
                
              }
              stat_yellow = couleurFaux_yellow + couleurVrai_yellow
              stat_red =  couleurFaux_red + couleurVrai_red

              if (stat_yellow < stat_red) {
                finale_color = 'red'
              } else if (stat_red < stat_yellow) {
                //yellow
                finale_color = '#F8B62C'
              } else if (stat_red === stat_yellow) {
                finale_color = 'red'
              } else if (stat_red === 0 && stat_yellow === 0) {
                finale_color = 'green'
              } else if (stat_red === 0 && stat_yellow > 1) {
                //yellow
                finale_color = '#F8B62C'
              } else {
                finale_color = 'red'
              }      
              obj_normale.mission_id = obj_mission_Risk_end.id_mission_end[t]
              obj_normale.valeurColor = finale_color
              this.objResult.push(obj_normale)
            }
          }
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    paginationAllMissions (npage) {
      this.$vs.loading()
      this.search = ''
      this.$http.get(`${str}paginated-missions/`, { params: {page: npage, per_page:3} })
        .then((response) => {
          this.objResult = []
          let finale_color = ''
          let stat_yellow = ''
          let stat_red = ''
          const obj_mission_Risk = {
            id_mission: [],
            danger_obj: []
          }
          const obj_mission_Risk_end = {
            id_mission_end: [],
            danger_obj_end: []
          }

          this.missions = response.data.results
          const results = response.data.results
          this.pageCount = npage
          this.count = response.data.count
          this.repNext = str + (response.data.next).substr(34)
          this.repPrev = response.data.previous
          results.forEach(event => {
            if (event.missionRiskZoneAssessment.length) {
              obj_mission_Risk.id_mission.push(event.id)
              obj_mission_Risk.danger_obj.push(event.missionRiskZoneAssessment[0].questionHasFileHasSites)
            }

          })
          if (obj_mission_Risk.id_mission.length) {
            for (let i = 0; i < obj_mission_Risk.id_mission.length; i++) {
              this.danger_obj_end = []
              const risk_obj = obj_mission_Risk.danger_obj[i]
              risk_obj.forEach(event => {
                const obj = {
                  mission_id: obj_mission_Risk.id_mission[i],
                  conditionFaux: event.conditionFaux,
                  conditionNa: event.conditionNa,
                  conditionVrai: event.conditionVrai,
                  colorVrai: event.question.colorVrai,
                  //colorNa:event.question.colorNa,
                  colorFaux: event.question.colorFaux,
                  description: event.question.description,
                  site_name: event.site.name
                  //question:event.question,
                  //site:event.site
                }
                this.danger_obj_end.push(obj)
              })
              obj_mission_Risk_end.id_mission_end.push(obj_mission_Risk.id_mission[i])
              obj_mission_Risk_end.danger_obj_end.push(this.danger_obj_end)
            }

          }
          if (obj_mission_Risk_end.id_mission_end.length) {
            for (let t = 0; t < obj_mission_Risk_end.id_mission_end.length; t++) {
              const obj_normale = {
                mission_id: '',
                valeurColor: ''
              }

              let couleurFaux_red = 0
              let couleurFaux_yellow = 0
              let couleurVrai_red = 0
              let couleurVrai_yellow = 0


              for (let y = 0; y < obj_mission_Risk_end.danger_obj_end.length; y++) {
                const obj_var = obj_mission_Risk_end.danger_obj_end[y]
                for (let z = 0; z < obj_var.length; z++) {
                  if (obj_mission_Risk_end.id_mission_end[t] === obj_var[z].mission_id) {

                    if (obj_var[z].conditionFaux === true) {
                      //countFaux++
                      if (obj_var[z].colorFaux === 'yellow') {
                        couleurFaux_yellow++
                      }
                      if (obj_var[z].colorFaux === 'red') {
                        couleurFaux_red++
                      }
                    }

                    if (obj_var[z].conditionVrai === true) {
                      //countVrai++
                      if (obj_var[z].colorVrai === 'yellow') {
                        couleurVrai_yellow++
                      }
                      if (obj_var[z].colorVrai === 'red') {
                        couleurVrai_red++
                      }
                    }
                  }
                }

              }
              stat_yellow = couleurFaux_yellow + couleurVrai_yellow
              stat_red = couleurFaux_red + couleurVrai_red

              if (stat_yellow < stat_red) {
                finale_color = 'red'
              } else if (stat_red < stat_yellow) {
                //yellow
                finale_color = '#F8B62C'
              } else if (stat_red === stat_yellow) {
                finale_color = 'red'
              } else if (stat_red === 0 && stat_yellow === 0) {
                finale_color = 'green'
              } else if (stat_red === 0 && stat_yellow > 1) {
                //yellow
                finale_color = '#F8B62C'
              } else {
                finale_color = 'red'
              }
              obj_normale.mission_id = obj_mission_Risk_end.id_mission_end[t]
              obj_normale.valeurColor = finale_color
              this.objResult.push(obj_normale)
            }
          }
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    }
  },

  created () {
    this.user_role = JSON.parse(localStorage.getItem('userInfo')).role
    window.Planifications = this
    this.planification_mission_data = {}
    this.getAllMissions()
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
        box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
        td{
          padding: 20px;
          &:first-child{
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }
          &:last-child{
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }
        td.td-check{
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
<style scoped>

</style>
